






import { defineComponent } from '@vue/composition-api';
import TeaserText from '@/components/storyblok/TeaserText.vue';
import ImageCaption from '@/components/storyblok/ImageCaption.vue';
import EduTitle from '@/components/storyblok/EduTitle.vue';
import RichText from '@/components/storyblok/RichText.vue';
import Markdown from '@/components/storyblok/Markdown.vue';
import DownloadButton from '@/components/storyblok/DownloadButton.vue';
import EmbeddedYoutubeVideo from '@/components/storyblok/EmbeddedYoutubeVideo.vue';
import EmbeddedVimeoVideo from '@/components/storyblok/EmbeddedVimeoVideo.vue';

export default defineComponent({
  name: 'ContentContainer',
  props: { blok: { type: Object } },
  components: { TeaserText, ImageCaption, EduTitle, RichText, Markdown, DownloadButton, EmbeddedYoutubeVideo, EmbeddedVimeoVideo },
});
